"use client";

import Select, {SelectClasses} from "@/app/_components/forms/Select";
import {SelectionItem} from "@/app/_components/forms/SelectionList";
import Campus from "@/app/types/Campus";
import {SelectProps} from "react-aria-components";
import * as _ from "lodash-es";

export interface CampusSelectionListProps {
	ariaLabel?: string;
	campusList: Campus[];
	getCampusListItemText?: (campus: Campus) => string;
	classes?: SelectClasses;
	fieldName?: string;
	label?: string;
}

const CampusSelectionList: React.FC<
	CampusSelectionListProps & SelectProps<HTMLSelectElement>
> = ({
	ariaLabel,
	campusList,
	getCampusListItemText = (campus) => campus.locationName,
	classes,
	fieldName,
	isRequired,
	label,
	isDisabled,
	selectedKey,
	disabledKeys,
	...props
}) => {
	const sortedCampuses = _.sortBy(campusList, getCampusListItemText);

	let selectedCampus = selectedKey;
	if (
		selectedCampus &&
		disabledKeys &&
		[...disabledKeys].includes(selectedCampus)
	) {
		selectedCampus = "";
	}

	return (
		<Select
			classes={classes}
			isRequired={isRequired}
			name={fieldName ?? "campus"}
			labelText={label}
			placeholder="Select a Campus"
			disabledKeys={disabledKeys ?? ["none"]}
			selectedKey={selectedCampus}
			onSelectionChange={props.onSelectionChange}
			items={sortedCampuses}
			isDisabled={isDisabled ?? campusList.length === 0}
			aria-label={ariaLabel}
			{...props}
		>
			{(item) => {
				return (
					<SelectionItem id={item.campusId} key={item.campusId}>
						{getCampusListItemText?.(item)}
					</SelectionItem>
				);
			}}
		</Select>
	);
};

export default CampusSelectionList;
